"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const js_cookie_1 = __importDefault(require("js-cookie"));
const audioPlayer_1 = require("@app/services/audioPlayer");
const audioPathNames_1 = require("@app/enums/audioPathNames");
const useCoins = () => {
    const [coinCount, setCoinCount] = (0, react_1.useState)(0);
    const [rubyCount, setRubyCount] = (0, react_1.useState)(0);
    const [diamondCount, setDiamondCount] = (0, react_1.useState)(0);
    const [correctCounter, setCorrectCounter] = (0, react_1.useState)(0);
    const [language, setLanguage] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        const langId = js_cookie_1.default.get("lang_id");
        setLanguage(langId);
    }, []);
    (0, react_1.useEffect)(() => {
        const rootElement = document.getElementById('ezspeech-react-front');
        const coins = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-coins')) || 0;
        const diamonds = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-diamonds')) || 0;
        const rubies = (rootElement === null || rootElement === void 0 ? void 0 : rootElement.getAttribute('data-rubies')) || 0;
        setCoinCount(+coins);
        setRubyCount(+rubies);
        setDiamondCount(+diamonds);
    }, []);
    const addCoin = (rubyThreshold = 0, diamondThreshold = 0) => {
        let gifElement = '';
        let spanElement = '';
        let coinType = '';
        setCorrectCounter((prevCounter) => {
            const newCounter = prevCounter + 1;
            switch (newCounter) {
                case diamondThreshold:
                    gifElement = '.diamond_gif';
                    spanElement = '.diamonds';
                    coinType = +language === 1 ? 'Diamond' : 'Diamond_en';
                    console.debug(coinType, 111111);
                    setDiamondCount((prevCount) => +prevCount + 1);
                    saveEarnedCoins(0, 0, 1).then(res => {
                        //
                    });
                    return 0;
                case rubyThreshold:
                    gifElement = '.ruby_gif';
                    spanElement = '.rubies';
                    coinType = +language === 1 ? 'Rubin' : 'Rubin_en';
                    setRubyCount((prevCount) => +prevCount + 1);
                    saveEarnedCoins(0, 1, 0).then(res => {
                    });
                    return newCounter;
                default:
                    gifElement = '.coin_gif';
                    spanElement = '.coins';
                    coinType = +language === 1 ? 'Coin' : 'Coin_en';
                    setCoinCount((prevCount) => +prevCount + 1);
                    saveEarnedCoins(0, 0, 1).then(res => {
                    });
                    return newCounter;
            }
        });
        setTimeout(() => {
            audioPlayer_1.audioPlayer.playAudio(audioPathNames_1.AudioPathNames[coinType]);
        }, 100);
    };
    const clearCoinCounter = () => {
        setCorrectCounter(0);
    };
    const saveEarnedCoins = (coins, rubies, diamonds) => __awaiter(void 0, void 0, void 0, function* () {
        const coinsEarned = {
            coin: coins,
            ruby: rubies,
            diamond: diamonds,
        };
        try {
            const response = yield fetch('/api/save_reward/', {
                method: 'POST',
                body: JSON.stringify(coinsEarned),
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': js_cookie_1.default.get("csrftoken")
                },
            });
            const result = yield response.json();
        }
        catch (error) {
            console.error('Error saving coins:', error);
        }
    });
    return {
        coinCount,
        rubyCount,
        diamondCount,
        addCoin,
        clearCoinCounter,
        saveEarnedCoins,
        correctCounter,
    };
};
exports.default = useCoins;
